<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <div class="header accent p-24 h-160" fxLayout="row" fxLayoutAlign="start center">

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">





        <div class="h1 pt-32">
            Horizontal Stepper
        </div>

        <p class="pb-32">
            Angular Material's stepper provides a wizard-like workflow by dividing content into logical steps.
            <code>mat-horizontal-stepper</code> selector can be used to create a horizontal stepper.
        </p>

        <div class="content p-24" fusePerfectScrollbar>

            <!-- HORIZONTAL STEPPER EXAMPLE -->
            <mat-horizontal-stepper class="mat-elevation-z4" >

                <mat-step [stepControl]="horizontalStepperStep1">
                  <ng-template matStepLabel>JSON de login</ng-template>

                  <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" fxFlex="1 0 auto">

                      <!-- REACTIVE FORM EXAMPLE -->

                      <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                            fxFlex="1 0 auto" name="form" [formGroup]="form">

                          <div class="h2 mb-24">Reactive Form Example</div>

                          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                  <mat-label>Logo</mat-label>
                                  <input matInput formControlName="firstName" required autocomplete="false"
                                  (keyup)="updateJson($event,1)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>Logo is required!</mat-error>
                              </mat-form-field>

                              <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                                  <mat-label>Name</mat-label>
                                  <input matInput formControlName="lastName" autocomplete="false" required
                                  (keyup)="updateJson($event,2)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>Name is required!</mat-error>
                              </mat-form-field>

                          </div>

                          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                  <mat-label>Screen name</mat-label>
                                  <input matInput formControlName="firstName" autocomplete="false" required
                                  (keyup)="updateJson($event,3)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>First Name is required!</mat-error>
                              </mat-form-field>

                              <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                                  <mat-label>languageSelection</mat-label>
                                  <input matInput formControlName="lastName" autocomplete="false" required
                                  (keyup)="updateJson($event,4)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>languageSelection</mat-error>
                              </mat-form-field>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                  <mat-label>Msg Access</mat-label>
                                  <input matInput formControlName="firstName" autocomplete="false" required
                                  (keyup)="updateJson($event,5)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>Msg Access is required!</mat-error>
                              </mat-form-field>


                          </div>

                          <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="100">
                                  <mat-label>Texto</mat-label>
                                  <textarea matInput formControlName="address" required
                                  (keyup)="updateJson($event,6)"></textarea>
                                  <mat-error>Texto is required!</mat-error>
                              </mat-form-field>

                          </div>

                          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                  <mat-label>inputPlaceHolderUser</mat-label>
                                  <input matInput formControlName="firstName" autocomplete="false" required
                                  (keyup)="updateJson($event,7)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>inputPlaceHolderUser is required!</mat-error>
                              </mat-form-field>

                              <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                                  <mat-label>inputPlaceHolderPass</mat-label>
                                  <input matInput formControlName="lastName" autocomplete="false" required
                                  (keyup)="updateJson($event,8)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>inputPlaceHolderPass is required!</mat-error>
                              </mat-form-field>

                          </div>

                          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                  <mat-label>label</mat-label>
                                  <input matInput formControlName="firstName" autocomplete="false" required
                                  (keyup)="updateJson($event,9)">
                                  <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                  <mat-error>label is required!</mat-error>
                              </mat-form-field>

                          </div>
                      </form>

                      <!-- / REACTIVE FORM EXAMPLE -->

                      <div class="mat-card form-errors-model p-24 mat-elevation-z4">
                          <div class="h2 mb-24">Reactive Form Model</div>
                          <pre><code></code></pre><!--{{stringResponse}}-->
                          <!-- <pre><code>{{response | json}}</code></pre> -->
                        <!--  <pre><code>{{form.getRawValue() | json}}</code></pre> -->
                      </div>

                  </div>


                </mat-step>

                <mat-step [stepControl]="horizontalStepperStep2">

                    <form fxLayout="column" [formGroup]="horizontalStepperStep2">

                        <ng-template matStepLabel>JSON de configuración</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="row">

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Address</mat-label>
                                <textarea matInput formControlName="address" required>
                                    1600 Amphitheatre Pkwy
                                </textarea>
                                <mat-error>Address is required!</mat-error>
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button class="mr-8" mat-raised-button matStepperPrevious type="button" color="accent">
                                Previous
                            </button>
                            <button mat-raised-button matStepperNext type="button" color="accent">
                                Next
                            </button>
                        </div>

                    </form>

                </mat-step>


            </mat-horizontal-stepper>
            <!-- / HORIZONTAL STEPPER EXAMPLE -->

        </div>

    </div>
    <!-- / CONTENT -->

</div>
